@for (child of displayItems; track child; let i = $index) {
  @if (child.visible === false ? false : true) {
    <li
      [ngClass]="{ 'active-menuitem': isActive(i) }"
      [class]="child.badgeStyleClass || ''"
      >
      @if (!child.routerLink) {
        <a
          [href]="child.url || '#'"
          (click)="itemClick($event, child, i)"
          (mouseenter)="onMouseEnter(i)"
          class="ripplelink"
          [attr.tabindex]="!visible ? '-1' : null"
          [attr.target]="child.target"
          [id]="(child.id ?? '') + i"
          >
          @if (child.icon) {
            <i [class]="child.icon"></i>
          }
          <span>{{ child.label }}</span>
          @if (child.badge) {
            <span class="menuitem-badge">{{ child.badge }}</span>
          }
          @if (child.items) {
            <i class="submenu-icon pi pi-chevron-down"></i>
          }
        </a>
      }
      @if (child.routerLink) {
        <a
          (click)="itemClick($event, child, i)"
          (mouseenter)="onMouseEnter(i)"
          class="ripplelink"
          [routerLink]="child.routerLink"
          routerLinkActive="active-menuitem-routerlink"
          [routerLinkActiveOptions]="{ exact: true }"
          [attr.tabindex]="!visible ? '-1' : null"
          [attr.target]="child.target"
          [id]="(child.id ?? '') + i"
          >
          @if (child.icon) {
            <i [class]="child.icon"></i>
          }
          <span>{{ child.label }}</span>
          @if (child.badge) {
            <span ng class="menuitem-badge">{{
              child.badge
            }}</span>
          }
          @if (child.items) {
            <i class="submenu-icon pi pi-chevron-down"></i>
          }
        </a>
        }
        <div class="layout-menu-tooltip">
          <div class="layout-menu-tooltip-arrow"></div>
          <div class="layout-menu-tooltip-text">{{ child.label }}</div>
        </div>
        @if (child.items) {
          <ul
            app-sub-menu
            [item]="child"
            [visible]="isActive(i)"
            [reset]="reset"
            [parentActive]="isActive(i)"
            [activeUrl]="activeUrl"
      [@children]="
        root
          ? isActive(i)
            ? 'visible'
            : 'hidden'
          : isActive(i)
          ? 'visibleAnimated'
          : 'hiddenAnimated'
      "
          ></ul>
        }
      </li>
    }
  }
